<template>
  <div class="journey">
    <ba-targeting v-if="isTargetView" />
    <ba-pane v-else />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

import BaPane from '@/components/journey/Pane'
import BaTargeting from '@/components/targeting/Pane'
import { EventBus } from '@/libs/event-bus'

export default {
  name: 'Journey',
  components: {
    BaPane,
    BaTargeting
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState([
      'journeyOptions',
      'journeyTargetingOptions'
    ]),
    isTargetView () {
      return this.journeyTargetingOptions && this.journeyTargetingOptions.direction
    }
  },
  methods: {
    ...mapMutations([
      'setJourneyOptions',
      'setJourneyTargetingOptions'
    ])
  }
}
</script>

<style lang="scss" scoped>
.journey {
}
</style>
